import React from "react";
import cx from "classnames";

const ArticleDifficultyLevelSelector = ({
  selectedLevel,
  setSelectedLevel,
}) => {
  const Level = ({ level, color, active = false }) => (
    <div className={cx("text-center", { active: active })}>
      <svg
        width="123"
        height="10"
        viewBox="0 0 123 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="123" height="6" fill={color} />
        <path d="M61 10L55 6H67L61 10Z" fill={color} />
      </svg>
      <p style={{ color }}>{level}</p>
    </div>
  );

  return (
    <div className="article-difficulty-level-selector d-sm-inline-flex">
      <button
        className="button"
        onClick={() =>
          setSelectedLevel({
            ...selectedLevel,
            beginner: !selectedLevel["beginner"],
          })
        }
      >
        <Level
          color="#21CAB7"
          level="Beginner"
          active={selectedLevel["beginner"]}
        />
      </button>
      <button
        className="button"
        onClick={() =>
          setSelectedLevel({
            ...selectedLevel,
            intermediate: !selectedLevel["intermediate"],
          })
        }
      >
        <Level
          color="#F2994A"
          level="Intermediate"
          active={selectedLevel["intermediate"]}
        />
      </button>
      <button
        className="button"
        onClick={() =>
          setSelectedLevel({
            ...selectedLevel,
            advanced: !selectedLevel["advanced"],
          })
        }
      >
        <Level
          color="#2F80ED"
          level="Advanced"
          active={selectedLevel["advanced"]}
        />
      </button>
    </div>
  );
};

export default ArticleDifficultyLevelSelector;
